import { NgFor } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule, OnInit, ViewChild } from '@angular/core';
import {
  NguCarousel,
  NguCarouselConfig,
  NguCarouselDefDirective,
  NguCarouselNextDirective,
  NguCarouselPrevDirective,
  NguItemComponent,
  NguTileComponent,
} from '@ngu/carousel';

@Component({
  selector: 'app-partners-logos',
  templateUrl: './partners-logos.component.html',
  styleUrls: ['./partners-logos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NguCarousel, NguCarouselDefDirective, NguItemComponent, NgFor],
})
export class PartnersLogosComponent implements OnInit {
  @ViewChild('carousel') carousel: NguCarousel<any, any>;

  public logos: any[] = [
    {
      path: 'assets/images/demo/homepage/partners/America-Red-Cross-300x225.png',
    },
    {
      path: 'assets/images/demo/homepage/partners/BBB-300x225.png',
    },
    {
      path: 'assets/images/demo/homepage/partners/Boys-and-Girls-Club-300x225.png',
    },
    {
      path: 'assets/images/demo/homepage/partners/Court-Appointed-Special-Advocates-300x225.png',
    },
    {
      path: 'assets/images/demo/homepage/partners/Gigis-Playhouse-300x225.png',
    },
    {
      path: 'assets/images/demo/homepage/partners/Habitat-For-Humanity-300x225.png',
    },
    {
      path: 'assets/images/demo/homepage/partners/Jewish-National-Fund-300x225.png',
    },
    {
      path: 'assets/images/demo/homepage/partners/Leukemia-Lymphoma-Society-300x225.png',
    },
    {
      path: 'assets/images/demo/homepage/partners/Muscular-Dystrophy-Association-300x225.png',
    },
    {
      path: 'assets/images/demo/homepage/partners/Nation-Safety-Council-300x225.png',
    },
    {
      path: 'assets/images/demo/homepage/partners/United-Way-300x225.png',
    },
    {
      path: 'assets/images/demo/homepage/partners/YMCA-300x225.png',
    },
    {
      path: 'assets/images/demo/homepage/partners/Young-Life-300x225.png',
    },
  ];

  public carouselTile: NguCarouselConfig;

  public ngOnInit(): void {
    this.carouselTile = {
      grid: { xs: 2, sm: 2, md: 4, lg: 5, xl: 5, all: 0 },
      gridBreakpoints: { sm: 576, md: 768, lg: 992, xl: 1200 },
      slide: 1,
      interval: {
        timing: 3000,
        initialDelay: 1000,
      },
      speed: 300,
      loop: true,
      load: 3,
      velocity: 0,
      animation: 'lazy',
      point: {
        visible: true,
        hideOnSingleSlide: true,
      },
      touch: true,
      easing: 'cubic-bezier(0, 0, 0.2, 1)',
    };
  }
}

@NgModule({
  imports: [
    NguCarousel,
    NguTileComponent,
    NguCarouselDefDirective,
    NguCarouselNextDirective,
    NguCarouselPrevDirective,
    NguItemComponent,
    PartnersLogosComponent,
  ],
  exports: [PartnersLogosComponent],
})
export class PartnersLogosModule {}
